import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'
import 'moment/locale/ja'

ReactDOM.render(<App />, document.getElementById('root'))
